// Promise 封装的接口
// 在要使用的页面中引入
// import apiList from '@/api/apiList'
// 使用 apiList.apiGet(this.params) 调用
import http from '@/http/index'

const apiList = {
  getList: (params) => http.post('officialWebsite/getDdicList', params),
  /**
   * @desc 商务合作接口
   * @param {*} enterpriseName 企业名称
   * @param {*} content 留言
   * @param {*} name 姓名
   * @param {*} phoneNumber 电话
   * @param {*} intendedProduct 意向产品
   * @param {*} roleType 角色
   * @param {*} email 邮箱
  */
  cooperationInsert: params => http.post('officialWebsite/insertBusinessCooperation', params)
}
export default apiList
